<template>
    <div class="main_wrapper container ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Select Days</h1>
                </div>
            </div>
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules" :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="() => goNext('userForm')">
                <el-form-item prop="schedule" class="job_filters_form_checkbox">
                    <el-checkbox class="checkbox_w100" v-for="(value, day) in formsData.userForm.schedule.value" :key="day" v-model="formsData.userForm.schedule.value[day]">{{ $filters.capitalize(day) }}</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <span>Minimum Rate</span>
                    <el-input v-model="formsData.userForm.minRate.value" placeholder="Enter minimum hourly rate" >
                        <template #append>
                            <span class="currency">AUD</span>
                        </template>
                    </el-input>
                    <span class="text-center divider">OR</span>
                    <el-input v-model="formsData.userForm.minAnnual.value" placeholder="Enter minimum annual payment">
                        <template #append>
                            <span class="currency">AUD</span>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit_page" type="blue" @click="() => goNext('userForm')" :disabled="formsData.userForm.disabled">
                        Continue 
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>


<script>
import {onMounted,inject} from 'vue';
import {addIcons} from 'ionicons'
import {arrowBackOutline} from 'ionicons/icons'
import {useStore} from 'vuex'
import {useRouter,} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import formMasks from '@/hooks/form/mask/mask'
import {ElInput} from 'element-plus'
import IMaskDirective from '@/directives/vue-imask/directive';
import IMask from 'imask/esm/imask';

addIcons({
    'arrow-back-outline': arrowBackOutline
})

export default {
    components: {
        ElInput
    },
    props: {
        onClose: {
            type: Function,
            default: () => {}
        },
        onFilter: {
            type: Function,
            default: () => {}
        }
    },
    directives: {
        imask: IMaskDirective
    },
    setup(props) {
        const $store = useStore()
        const $router = useRouter()
        const setPageClassGlobal = inject('setPageClassGlobal');

        const userData = $store.getters.GET_USER_DATA;
        const schedule = userData.schedule;
        const minRate = $store.getters.getJobFilters.minRate || userData.minRate;
        const minAnnual = $store.getters.getJobFilters.minAnnual || userData.minAnnual;

        const formsDataArray = {
            userForm: {
                schedule: {
                    value: $store.getters.getJobFilters.schedule || Object.keys(schedule).reduce((value, key) => {
                        value[key] = !!parseInt(schedule[key]);
                        return value;
                    }, {}),
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'schedule', callback, setFormValidation);
                        },
                    }],
                },
                minRate: {
                    ref: {},
                    value: minRate ? IMask.createMask(formMasks.rate).resolve("" + minRate) : '',
                    mask: formMasks.rate,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            console.log('validate');
                            formValidate.validate(rule, formField, 'minRate', callback, setFormValidation);
                        },
                    }]
                },
                minAnnual: {
                    ref: {},
                    value: minAnnual ? IMask.createMask(formMasks.rate).resolve("" + minAnnual): '',
                    mask: formMasks.rate,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'minAnnual', callback, setFormValidation);
                        }
                    }]
                }
            }
        };

        const selectAll = () => {
            for (let value in formsData.userForm.schedule.value) {
                formsData.userForm.schedule.value[value] = true;
            }
        }

        const goBack = () => {

            $router.push({
                name: 'search'
            })
        };

        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    $store.dispatch('setJobFiltersData', getFormValues(formName));
                    props.onFilter();
                    props.onClose();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        };

        onMounted(() => {
            setPageClassGlobal('global_job_filters_page');
            setFormRefs();
            checkFormValidation('userForm', false);
        });

        const {
            onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            goBack,
            goNext,
            selectAll,
        }
    },
}
</script>
